/* eslint-disable max-len */
import Keycloak from 'keycloak-js'
import { removeSelectedProfile } from '../utils/user/profileHelper'

const kcInitOptionsLexIdp = {
  idpHint: 'lex',
}

const kcInitOptionsFtdIdp = {
  idpHint: 'lti-ftd',
}

const _kc = new Keycloak({
  realm: 'ias',
  url: process.env.REACT_APP_KEYCLOAK_URL,
  clientId: 'bncc',
})

const clearLocalStorage = () => {
  localStorage.removeItem('regionalIds')
  localStorage.removeItem('currentUser')
  localStorage.removeItem('import-selected')
  localStorage.removeItem('showedInstructionInstrumentId')
  removeSelectedProfile()
}

const doLogin = () => {
  clearLocalStorage()
  _kc.login()
}

const doLoginLex = () => {
  _kc.login(kcInitOptionsLexIdp)
}

const doLoginFTD = () => {
  _kc.login(kcInitOptionsFtdIdp)
}

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = onAuthenticatedCallback => {
  _kc
    .init({
      onLoad: 'check-sso',
      checkLoginIframe: false,
    })
    .then(() => {
      onAuthenticatedCallback()
    })
}

const getRefreshToken = () => _kc.refreshToken

const doUpdateToken = minValue => _kc.updateToken(minValue)

const isLoggedIn = () => !!_kc.authenticated

const getUsername = () => _kc.tokenParsed?.preferred_username

const getUserId = () => _kc.tokenParsed?.sub

const getName = () => _kc.tokenParsed?.name

const getEmail = () => _kc.tokenParsed?.email

const getGroups = () => _kc.tokenParsed?.groups

const getPartnershipCollaboratorName = () => {
  const name = _kc.tokenParsed?.name
  return name ?? 'Respondente'
}

const getProfiles = () =>
  _kc.realmAccess?.roles
    .filter(role => role.startsWith('ROLE_') && role !== 'ROLE_LMS')
    .map(profile => profile.replace('ROLE_', ''))

const hasRole = roles => roles.some(role => _kc.hasRealmRole(`ROLE_${role}`))

const isFtdUser = () => {
  return isLoggedIn() && getGroups().includes('/GROUP_FTD_MIGRATION_USER')
}

const doLogout = () => {
  clearLocalStorage()

  if (isFtdUser()) {
    window.IonicaMenu.logout()
  }

  _kc.logout()
}

const doLogoutFtd = async () => {
  clearLocalStorage()
  await _kc.logout({ redirectUri: process.env.REACT_APP_FTD_REDIRECT_URI })
}

const getToken = () => {
  return new Promise(resolve => {
    if (_kc.isTokenExpired()) {
      _kc
        .updateToken()
        .then(function(refreshed) {
          if (refreshed) {
            resolve(_kc.token)
          }
        })
        .catch(() => {
          doLogout()
        })
    } else {
      resolve(_kc.token)
    }
  })
}

const forceLogout = () => {
  doLogout()
}

const UserService = {
  initKeycloak,
  doLogin,
  doLoginLex,
  doLoginFTD,
  doLogout,
  isLoggedIn,
  getToken,
  getUsername,
  getName,
  hasRole,
  getProfiles,
  getEmail,
  forceLogout,
  getRefreshToken,
  getUserId,
  getPartnershipCollaboratorName,
  getGroups,
  isFtdUser,
  doLogoutFtd,
  doUpdateToken,
}

export default UserService
